import {type TemplateResult} from "lit";

export function elementFromTemplateResult<T extends Element>(templateResult: TemplateResult): T {
    const {strings, values} = templateResult;
    const v = [...values, ""]; // + last empty part
    const renderedString = strings.reduce((acc, s, i) => acc + s + JSON.stringify(v[i]), "");
    return elementFrom(renderedString);
}

export function elementFrom<T extends Element>(htmlTemplate: string): T {
    const template = templateContaining(htmlTemplate);
    return importTemplate(template).firstElementChild! as T;
}

export function elementsFrom<T extends Element>(htmlTemplate: string): T[] {
    const template = templateContaining(htmlTemplate);
    return Array.from(importTemplate(template).children).map(it => it as T);
}

export function nodesFrom(htmlTemplate: string): Node[] {
    const template = templateContaining(htmlTemplate);
    return Array.from(importTemplate(template).childNodes);
}

export function nodesFromElements(elements: Element[]): NodeList {
    const fragment = document.createDocumentFragment();
    elements.forEach(elem => fragment.appendChild(elem.cloneNode(true)));
    return fragment.childNodes;
}

export function divContaining(htmlTemplate: string): Element {
    const element = document.createElement("div");
    element.append(...nodesFrom(htmlTemplate));
    return element;
}

export function templateContaining(htmlTemplate: string): HTMLTemplateElement {
    const template = document.createElement("template");
    template.innerHTML = htmlTemplate;
    return template;
}

export function fragmentContaining(htmlTemplate: string): DocumentFragment {
    return importTemplate(templateContaining(htmlTemplate));
}

export function fragmentOf(template: HTMLTemplateElement): DocumentFragment {
    return importTemplate((template.cloneNode(true) as HTMLTemplateElement));
}

function importTemplate(template: HTMLTemplateElement): DocumentFragment {
    return document.importNode(template.content, true);
}